import { Divider, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import type { UserProfile } from '../../services/userService';

interface UserMenuActionsProps {
  userProfile: UserProfile | null;
  onSettings: () => void;
  onLogout: () => void;
}

export const UserMenuActions = ({ userProfile, onSettings, onLogout }: UserMenuActionsProps) => (
  <>
    {userProfile?.CanShowProfileNavigation && (
      <>
        <MenuItem
          onClick={onSettings}
          disabled={!userProfile?.ProfileFormKey && !userProfile?.ProfileUrl}
        >
          <ListItemIcon>
            <PersonOutlineIcon fontSize="small" />
          </ListItemIcon>
          My profile
        </MenuItem>
        <Divider />
      </>
    )}
    <MenuItem onClick={onLogout}>
      <ListItemIcon>
        <LogoutIcon fontSize="small" />
      </ListItemIcon>
      Log out
    </MenuItem>
    {userProfile?.VersionLabel && (
      <>
        <Divider />
        <MenuItem disabled sx={{ opacity: 1, cursor: 'default' }}>
          <ListItemText
            primary={userProfile.VersionLabel}
            primaryTypographyProps={{ variant: 'caption', color: 'text.secondary' }}
          />
        </MenuItem>
      </>
    )}
  </>
);
